import { configureStore } from "@reduxjs/toolkit";
import uiSlice from "./ui-slice";
import securitySlice from './security-slice';
import brandSlice from "./brand-slice";
import localizationSlice from "./localization-slice";
import productSlice from "./product-slice";
import contentSlice from "./content-slice";

const store = configureStore({
    reducer: {
        ui: uiSlice.reducer, security: securitySlice.reducer, brand: brandSlice.reducer,
        localization: localizationSlice.reducer, product : productSlice.reducer,content : contentSlice.reducer
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware({
        serializableCheck: false,
    }),
});

export default store;